<template>
  <BuildingPage title="报告审批" description="审批页预留待我审批、已处理、审批记录等入口，后续根据流程接口补齐。" />
</template>

<script>
import BuildingPage from '@/views/report/building/building.vue'

export default {
  name: 'ReportAuditPage',
  components: {
    BuildingPage
  }
}
</script>
